'use client';

import { useLayoutEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { clearInProgressGame, getInProgressGame } from '@/utils/in-progress-game/in-progress-game';
import { POST_LOGIN_ACTION_TYPE, setPostLoginAction } from '@/utils/post-login-action/post-login-action';
import { isPageReload } from '@/logic/game-shell/navigation-entry-type';
import { GameLaunchMode } from '@/utils/url/game-launch-mode';

/**
 * After a full lobby refresh with an embedded game in flight, re-queue embed launch
 * for the existing post-login action handler to consume once the session is ready.
 */
export const useInProgressGameRecovery = (): void => {
    const pathname = usePathname();
    const recoveredRef = useRef(false);

    useLayoutEffect(() => {
        if (recoveredRef.current) {
            return;
        }

        if (!isPageReload()) {
            clearInProgressGame();
            return;
        }

        const pendingGame = getInProgressGame();
        if (!pendingGame) {
            return;
        }

        recoveredRef.current = true;
        clearInProgressGame();

        if (pendingGame.pathname !== pathname) {
            return;
        }

        setPostLoginAction({
            type: POST_LOGIN_ACTION_TYPE.LAUNCH_GAME,
            url: pendingGame.launcherUrl,
            launchMode: GameLaunchMode.EMBED
        });
    }, [pathname]);
};
